import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MessageEntity } from './message.entity';
import { SegmentEntity } from './segment.entity';

@Index('_message__segment__message__id_fk', ['fkMessageId'], {})
@Index('_message__segment__segment__id_fk', ['fkSegmentId'], {})
@Entity('_message__segment')
export class MessageSegmentEntity extends BaseEntity {
	@Column('int', { name: '_fk__message__id', nullable: true, unsigned: true })
	public fkMessageId!: number | null;

	@Column('int', { name: '_fk__segment__id', nullable: true, unsigned: true })
	public fkSegmentId!: number | null;

	@ManyToOne(() => MessageEntity, (message) => message.messageSegments, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__message__id', referencedColumnName: 'id' }])
	public fkMessage!: MessageEntity;

	@ManyToOne(() => SegmentEntity, (segment) => segment.messageSegments, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__segment__id', referencedColumnName: 'id' }])
	public fkSegment!: SegmentEntity;
}
